var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration-form"},[(_vm.localShowModal)?_c('div',{staticClass:"registration-form__overlay"},[(_vm.isLoading)?[_c('modal-loading',{attrs:{"show":_vm.isLoading},on:{"close":_vm.closeModal}})]:[_c(_vm.componentName,{tag:"component",attrs:{"tur":_vm.tur},on:{"close":_vm.closeModal,"cancel":_vm.closeModal,"send-booking":_vm.sendBooking,"ok":_vm.closeModal}})]],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d404ee9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/RegistrationForm.vue
// module id = 87
// module chunks = 0